import axios from '@src/utils/axios'

const module = 'industry'
const axiosInstance = axios(false);

export default {
  'pagination': (ctx, data) => axiosInstance.get(`/${module}/paginate`, {params:data}),
  'create': (ctx, data) => axiosInstance.post(`/${module}`, data),
  'update': (ctx, data) => {return axiosInstance.put(`/${module}/` + data.id, data)},
  'delete': (ctx, data) => {return axiosInstance.delete(`/${module}/` + data.id, data)},
  'find': async (ctx, data) => {return await axiosInstance.get(`/${module}/` + data.id)},
  'all': () => axiosInstance.get(`/${module}/all`),
  'getSourceCompany': () => axiosInstance.get(`/${module}/company_sources`),
  'xopa_industry': () => axiosInstance.get(`/${module}/xopa`)
}